module.exports = __webpack_public_path__ + "img/tick_ico (1).23ebb805.svg";